<template>
	<v-container justify-center>
	  <ChangePasswordForm />
	</v-container>
</template>

<script>
  import ChangePasswordForm from '@/components/ChangePasswordForm'
 

  export default {
    name: 'change-password',
    components: {
      ChangePasswordForm,
    }
  }
</script>

